import { render, staticRenderFns } from "./LegalDocsList.vue?vue&type=template&id=48f3e439&scoped=true"
import script from "./LegalDocsList.vue?vue&type=script&lang=js"
export * from "./LegalDocsList.vue?vue&type=script&lang=js"
import style0 from "./LegalDocsList.vue?vue&type=style&index=0&id=48f3e439&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f3e439",
  null
  
)

export default component.exports